// Range inline - bez Poppera, content zawsze widoczny (do użycia w mobilnym overlay)

import React, { FC, useState, useEffect } from 'react';
import { Range as RangeInput } from 'react-range';
import { Trans } from 'react-i18next';
import remove from 'lodash/remove';

import { IProductsFilter } from 'api/types';
import { Button, Input } from 'components/controls';

import styles from 'theme/components/controls/Range/Range.module.scss';

interface IFilter {
  filter_id: string;
  filter_value: string;
  filter_type?: string;
}

interface IProps {
  queryFilters: IFilter[];
  onChange: (filters: IFilter[], currentFilter: string) => void;
  filter: IProductsFilter;
}

const RangeInline: FC<IProps> = ({ filter, queryFilters, onChange }) => {
  const initialMin = Math.floor(Number(filter.values[0].value));
  const initialMax = Math.ceil(Number(filter.values[1].value));
  const [values, setValues] = useState(
    initialMin <= initialMax ? [initialMin, initialMax] : [initialMax, initialMin]
  );

  useEffect(() => {
    const rangeFilter = queryFilters.find((o) => o.filter_id === filter.id);
    if (rangeFilter) {
      const rangeFilterValues = rangeFilter.filter_value.split(';');
      const parsedValues = [parseInt(rangeFilterValues[0]), parseInt(rangeFilterValues[1])];
      setValues(parsedValues[0] <= parsedValues[1] ? parsedValues : [parsedValues[1], parsedValues[0]]);
    }
  }, []);

  const isValidRange =
    values[0] > parseFloat(filter.values[0].value) &&
    values[1] < parseFloat(filter.values[1].value);

  const areValuesSorted = values[0] <= values[1];

  return (
    <div className={styles.content} style={{ border: 'none', padding: 0 }}>
      <div>
        <div className={styles.inputWrapper}>
          <Input
            value={values[0].toString()}
            onChange={(value) => {
              if (parseInt(value) > values[1]) return;
              setValues([parseInt(value || filter.values[0].value), values[1]]);
            }}
          />
          <div className={styles.inputDash} />
          <Input
            value={values[1].toString()}
            onChange={(value) => {
              if (parseInt(value) > parseInt(filter.values[1].value)) return;
              setValues([values[0], parseInt(value || filter.values[1].value)]);
            }}
          />
        </div>
        <div className={styles.rangeWrapper}>
          {isValidRange && areValuesSorted && (
            <RangeInput
              step={1}
              min={parseFloat(filter.values[0].value)}
              max={parseFloat(filter.values[1].value)}
              values={values}
              onChange={(values) => setValues(values)}
              renderTrack={({ props, children }: any) => (
                <div
                  {...props}
                  style={{ ...props.style, height: '4px', width: '100%', backgroundColor: '#D9D9D9' }}>
                  <div
                    style={{
                      width: `${((values[1] - values[0]) * 100) / (parseInt(filter.values[1].value) - parseInt(filter.values[0].value))}%`,
                      left: `${((values[0] - parseInt(filter.values[0].value)) * 100) / (parseInt(filter.values[1].value) - parseInt(filter.values[0].value))}%`
                    }}
                    className={styles.innerTrack}
                  />
                  {children}
                </div>
              )}
              renderThumb={({ props }) => (
                <div
                  {...props}
                  style={{ ...props.style, height: '15px', width: '15px', backgroundColor: '#D9D9D9', borderRadius: '50%' }}
                />
              )}
            />
          )}
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          ghost
          onClick={() => {
            onChange([...remove(queryFilters, (o) => o.filter_id !== filter.id)], filter.id);
          }}>
          <Trans>Wyczyść</Trans>
        </Button>
        <Button
          onClick={() => {
            onChange(
              [
                ...queryFilters.filter((f) => f.filter_id !== filter.id),
                { filter_id: filter.id, filter_value: `${values[0]};${values[1]}`, filter_type: filter.type }
              ],
              filter.id
            );
          }}>
          <Trans>Zastosuj</Trans>
        </Button>
      </div>
    </div>
  );
};

export default RangeInline;
